import { useState } from "react";
import { Content, Modal } from "../components";
import { Grid } from "@mui/material";

const Layout = (props) => {
    const [openModal, setOpenModal] = useState(false);
    const [contentModal, setContentModal] = useState({});
    const [update, setUpdate] = useState(0);

    const changeOpenModal = (flag) => {
        setOpenModal(flag);
    };

    const changeContentModal = (data) => {
        setContentModal(data);
    };

    const changeUpdate = (update) => {
        setUpdate(update);
    };

    return (
        <>
            {openModal && (
                <Modal
                    pos={props.pos}
                    openModal={openModal}
                    changeOpenModal={changeOpenModal}
                    contentModal={contentModal}
                    changeContentModal={changeContentModal}
                    changeAlert={props.changeAlert}
                    changeLoader={props.changeLoader}
                    update={update}
                    changeUpdate={changeUpdate}
                />
            )}
            <Grid container spacing={2} className="fadeIn animated">
                <Grid item xs={12}>
                    <Content
                        showSecondary={props.showSecondary}
                        openMenu={props.openMenu}
                        openMainMenu={props.openMainMenu}
                        mainMenu={props.mainMenu}
                        closeMenu={props.closeMenu}
                        pos={props.pos}
                        rolName={props.rolName}
                        openModal={openModal}
                        changeOpenModal={changeOpenModal}
                        contentModal={contentModal}
                        changeContentModal={changeContentModal}
                        changeAlert={props.changeAlert}
                        changeLoader={props.changeLoader}
                        loader={props.loader}
                        update={update}
                        changeUpdate={changeUpdate}
                        changeRolName={props.changeRolName}
                        changeSecondaryMenu={props.changeSecondaryMenu}
                        openSideBar={props.openSideBar}
                        showSideBar={props.showSideBar}
                        closeSideBar={props.closeSideBar}
                    />
                </Grid>
            </Grid>
        </>
    );
};

export default Layout;
